import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <footer className="section footer">
        <p className="copyright">
          copyright ©: TECH GIANT- All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Footer;
